import { Component, OnInit } from '@angular/core';
import {PressroomShareService} from '../../../Service/Share/PressroomShareService';
import {ImagePressroom} from '../../../Model/ImagePressroom';
import {Environement} from '../../../environement/environement';

@Component({
  selector: 'app-pressroom-contact',
  templateUrl: './pressroom-contact.component.html',
  styleUrls: ['./pressroom-contact.component.scss']
})
export class PressroomContactComponent implements OnInit {

  constructor(public pressroomShareService: PressroomShareService) { }

  ngOnInit() {
  }
  getImageSource(typePicto) {
    return Environement.BASE_API_URL + '/picto/' + typePicto;
  }
}
